import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const PersonChatIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="personChat" ref={ref} {...props}>
      <path d="M15.78,22.28a.75.75,0,0,1-.75-.75A3.51,3.51,0,0,0,11.52,18H6.16a3.51,3.51,0,0,0-3.5,3.51.75.75,0,0,1-1.5,0,5,5,0,0,1,5-5h5.36a5,5,0,0,1,5,5A.76.76,0,0,1,15.78,22.28Zm7-17.42v5.79c0,1.72-.06,2.46-1.54,3.6a37.34,37.34,0,0,1-3.48,2.26.7.7,0,0,1-.37.11.76.76,0,0,1-.38-.11.74.74,0,0,1-.37-.64V12.8H15a.75.75,0,0,1,0-1.5h2.36a.75.75,0,0,1,.75.75v2.49c.69-.43,1.56-1,2.19-1.48.95-.74.95-.93.95-2.41V4.86a1.08,1.08,0,0,0-1.08-1.08H11A1.08,1.08,0,0,0,9.92,4.86V6.19a.77.77,0,0,1,0,.15,4,4,0,1,1-1.48-.1V4.86A2.59,2.59,0,0,1,11,2.28h9.17A2.59,2.59,0,0,1,22.75,4.86ZM8.89,7.71a2.53,2.53,0,1,0,2.53,2.53A2.53,2.53,0,0,0,8.89,7.71Z" />
    </Icon>
  ),
) as IconWithRender;

PersonChatIcon.displayName = 'PersonChatIcon';
PersonChatIcon.renderIcon = (props) => <PersonChatIcon {...props} />;
export default PersonChatIcon;
